import {
    find as _find,
    get as _get,
    forEach as _forEach,
    filter as _filter,
    isEqual as _isEqual,
} from 'lodash';
import React from 'react';
import {withRouter} from 'react-router';
import {Button} from 'semantic-ui-react';

import {refetchQueryByName} from '@utils/apollo';
import DefaultForm from '@appComponents/DefaultForm';
import {renderModalError} from '@utils/forms';
import {showModal} from '@utils/modal';
import {routes} from '@constants/routes';
import {convertToInt, isUrlParamValid} from '@utils/helpers';

export class EventsInvoiceStatusForm extends DefaultForm {
    eventInvoiceStatusesCallback(response) {
        const eventInvoiceStatuses = _get(response, 'data.saveEventInvoiceStatuses', null);

        this.setState(() => ({eventInvoiceStatuses: eventInvoiceStatuses}));
        this.setField('invoice_statuses', {eventInvoiceStatuses: eventInvoiceStatuses});
    }

    componentDidMount() {
        if (!isUrlParamValid(this.props.formParams.optionsVariables.event)) {
            return showModal({
                isVisible: true,
                content: renderModalError('Event', routes.events.index.path),
            });
        }

        this.setCreateSuccessCallback((response) => {
            this.eventInvoiceStatusesCallback(response);
            refetchQueryByName('GetEventInvoiceStatuses');
        });

        this.setUpdateSuccessCallback((response) => this.eventInvoiceStatusesCallback(response));
    }

    componentDidUpdate(prevProps) {
        const {eventContents, eventInvoiceStatuses} = this.props.GraphQLOptionsData;

        if (eventContents && !_isEqual(eventContents, this.state.eventContents)) {
            let availableProducts = [];

            _forEach(eventContents, (eventContent) => {
                _forEach(eventContent.distributions, (distribution) => {
                    const hasUniqueProduct = _filter(availableProducts, {id: distribution.product.id});

                    if (!hasUniqueProduct.length && distribution.product.is_invoiceable) {
                        availableProducts.push(distribution.product);
                    }
                });
            });

            this.setField('invoice_statuses', {inputsData: availableProducts});
            this.setState(() => ({
                availableProducts: availableProducts,
                eventContents: eventContents,
            }));
        }

        if (eventInvoiceStatuses
            && !_isEqual(eventInvoiceStatuses, this.state.eventInvoiceStatuses)
            && !this.state.initialStateSet
        ) {
            this.setState(() => ({
                eventInvoiceStatuses: eventInvoiceStatuses,
                initialStateSet: true,
            }));
            this.setField('invoice_statuses', {eventInvoiceStatuses: eventInvoiceStatuses});
        }

        super.componentDidUpdate(prevProps);
    }

    renderDeleteButton() {
        return null;
    }

    renderCancelButton() {
        return null;
    }

    renderSaveButton(props) {
        const defaultProps = {
            color: 'blue',
            content: 'Save',
            disabled: this.props.submitting,
            icon: 'save',
            loading: this.props.submitting,
            type: 'submit',
        };

        return this.checkAuthorization(
            <Button
                {...defaultProps}
                {...props}
            />, this.state.defaultForm_formPrivileges);
    }

    prepareDataForSubmit = (data) => {
        const invoiceStatus = {...this.props.Model.dataMap['eventsInvoiceStatuses'], ...data};

        invoiceStatus.event = convertToInt(this.props.formParams.optionsVariables.event);
        invoiceStatus.invoice_statuses = _get(invoiceStatus, 'invoice_statuses', []);

        invoiceStatus.invoice_statuses.forEach((item) => {
            const invoiceStatus = _find(this.state.eventInvoiceStatuses, {product: {id: item.product}});

            if (invoiceStatus) {
                item.id = invoiceStatus.id;
            }

            item.product = convertToInt(item.product);
            item.invoice_status = convertToInt(item.invoice_status);
        });

        return invoiceStatus;
    };
}

export default withRouter(EventsInvoiceStatusForm);
